const ctx = self;
ctx.onmessage = function (e) {
    const imgd1 = new Uint8ClampedArray(e.data.width * e.data.height * 4);
    const imgd2 = new Uint8ClampedArray(e.data.width * e.data.height * 4);
    const imgd3 = new Uint8ClampedArray(e.data.width * e.data.height * 4);
    const imgd4 = new Uint8ClampedArray(e.data.width * e.data.height * 4);
    const imgd5 = new Uint8ClampedArray(e.data.width * e.data.height * 4);
    const imgd6 = new Uint8ClampedArray(e.data.width * e.data.height * 4);
    Convolute(e.data.imgbuffer, imgd1, e.data.width, e.data.height, [-1, 0, 1, -1, 0, 1, -1, 0, 1], true);
    Convolute(e.data.imgbuffer, imgd2, e.data.width, e.data.height, [-1, -1, -1, 0, 0, 0, 1, 1, 1], true);
    Convolute(e.data.imgbuffer, imgd3, e.data.width, e.data.height, [1, 0, -1, 1, 0, -1, 1, 0, -1], true);
    Convolute(e.data.imgbuffer, imgd4, e.data.width, e.data.height, [1, 1, 1, 0, 0, 0, -1, -1, -1], true);
    Convolute(e.data.imgbuffer, imgd5, e.data.width, e.data.height, [-1, -1, 0, -1, 0, 1, 0, 1, 1], true);
    Convolute(e.data.imgbuffer, imgd6, e.data.width, e.data.height, [1, 1, 0, 1, 0, -1, 0, -1, -1], true);
    Add(imgd1, imgd2);
    Add(imgd1, imgd3);
    Add(imgd1, imgd4);
    Add(imgd1, imgd5);
    Add(imgd1, imgd6);
    ctx.postMessage(imgd1);
};
function Convolute(pixels, dstimageData, width, height, filtermask, opaque) {
    const side = Math.round(Math.sqrt(filtermask.length));
    const halfSide = Math.floor(side / 2);
    const src = pixels;
    const sw = width;
    const sh = height;
    const w = sw;
    const h = sh;
    const output = dstimageData;
    const dst = output;
    let rmax = 0;
    let xmax = 0;
    let ymax = 0;
    const alphaFac = opaque ? 1 : 0;
    for (let y = 1; y < h - 1; +y++) {
        for (let x = 1; x < w - 1; +x++) {
            const sy = y;
            const sx = x;
            const dstOff = (y * w + x) * 4;
            let r = 0, g = 0, b = 0, a = 0;
            for (let cy = 0; cy < side; cy++) {
                for (let cx = 0; cx < side; cx++) {
                    const scy = sy + cy - halfSide;
                    const scx = sx + cx - halfSide;
                    if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                        const srcOff = (scy * sw + scx) * 4;
                        const wt = filtermask[cy * side + cx];
                        r += src[srcOff] * wt;
                        g += src[srcOff + 1] * wt;
                        b += src[srcOff + 2] * wt;
                        a += src[srcOff + 3];
                    }
                }
            }
            if (r > rmax) {
                rmax = r;
                xmax = x;
                ymax = y;
            }
            dst[dstOff] = r;
            dst[dstOff + 1] = g;
            dst[dstOff + 2] = b;
            dst[dstOff + 3] = a;
        }
    }
    return output;
}
function Add(imgdata1, imgdata2) {
    const l1 = imgdata1.length;
    const l2 = imgdata2.length;
    if (l1 != l2) {
        throw "mmImageUtils Add: ImageData1 and ImageData2 must be same sized.";
    }
    for (let i = 0; i < l1; i++) {
        imgdata1[i] = imgdata1[i] + imgdata2[i];
    }
}
//# sourceMappingURL=orthogonalmeasurement.worker.js.map